import { TabInfoBase } from 'app/buffer-graph/models/tab-info-base';
import { ItemOrderHistory } from 'app/buffer-graph/models/item-order-history/item-order-history';
import { ItemOrderHistoryFresh } from 'app/buffer-graph/models/item-order-history/item-order-history-fresh';
import { StateInfo } from 'app/buffer-graph/models/assortment-structure/state-info';
import { BalanceStructure } from 'app/buffer-graph/models/assortment-structure/balance-structure';
import {Moment} from "moment";
import {ItemInfo} from "../item-info";

type Data = { states: StateInfo[], balanceStructure: BalanceStructure };

export class AssortmentStructureTabInfo extends TabInfoBase<Data> {
    constructor(type: string, data: Data, itemInfo: ItemInfo, startDate: Moment, endDate: Moment, sharedGuid: string) {
        super('AssortmentStructure', type, data, itemInfo, startDate, endDate, sharedGuid);
    }

    get id(): string {
        return AssortmentStructureTabInfo.id;
    }

    static readonly id = 'AST';
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/assortment-structure/assortment-structure-tab-info.ts